// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SelectionBox {\n  pointer-events: none;\n  animation-name: fadeIn;\n  animation-duration: 0.3s;\n}\n\n.Annotation-svg-container:focus .SelectionBox-rect {\n  stroke: #38a7e8;\n  stroke-dasharray: 0;\n}\n\n.PageAnnotations.is-dragging .SelectionBox {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
